











































































































import Vue, { PropOptions } from "vue";
import { Integration, BotStatus } from "@/models";
import { botRules } from "@/rules/bots.rules";
import { OmniChatSchema } from "@omnichat/omnichat-model";

import PageListTradingHours from "@/components/bots/PageListTradingHours.vue";

export default Vue.extend({
  components: { PageListTradingHours },
  props: {
    bot: {
      type: Object,
    } as PropOptions<Integration>,
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newBot: (this as any).initializeBot(this.bot),
      botRules: {
        ...botRules.attr,
      },
      valid: true,
      loading: false,
      teams: this.$store.state.team && this.$store.state.team.teams,
    };
  },
  methods: {
    initializeBot(bot: Integration) {
      if (bot && bot.configuration) {
        const config = { ...bot.configuration };

        if (!config.defaultTeam) {
          config.defaultTeam = this.$store.state.bot.defaultTeamId;
        }

        if (!config.botTTL) {
          config.botTTL = 10;
        }

        if (!config.tradingHours) {
          config.tradingHours = this.defaultTradingHours();
        }

        if (!config.afterHoursMessageEnabled) {
          config.afterHoursMessageEnabled = false;
        }
        if (!config.afterHoursMessage) {
          config.afterHoursMessage = "";
        }

        return config;
      }
      return {
        botTTL: 10,
        title: "",
        greetingsMessage: "",
        defaultErrorMessage: "",
        defaultTeam: this.$store.state.bot.defaultTeamId,
        tradingHours: this.defaultTradingHours(),
        afterHoursMessageEnabled: false,
        afterHoursMessage: "",
      };
    },
    onCancel() {
      this.$emit("close");
    },
    async onSave() {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        this.loading = true;
        if (this.bot) {
          this.bot.configuration = this.newBot
            ? { ...this.newBot }
            : this.bot.configuration;
          await this.updateBot(this.bot);
        } else {
          await this.onSaveBot(this.newBot);
        }
        this.loading = false;
        this.$emit("close");
      }
    },
    async updateBot(bot: Integration) {
      try {
        await this.$store.dispatch("updateBot", bot);

        this.$store.commit("addSnackbar", {
          text: `Bot salvo com sucesso!`,
          color: "success",
        });
      } catch (error) {
        this.$store.commit("addSnackbar", {
          text: `Erro ao salvar bot: ${error.message}`,
        });
      }
    },
    async onSaveBot(bot: OmniChatSchema.BotStateMachine) {
      try {
        bot.initialState = {
          title: "primeiro nível default",
          handlerType: OmniChatSchema.BotHandlerType.botStateChangeHandler,
          index: 2,
          toState: {
            title: "",
            to: [],
          },
        };

        const botId = await this.$store.dispatch("createBot", bot);

        this.$store.commit("addSnackbar", {
          text: `Bot criado com sucesso!`,
          color: "success",
        });
        // this.$router.push(`/bots/${botId}`);
        await this.$store.dispatch('loadBots');
      } catch (error) {
        this.$store.commit("addSnackbar", {
          text: `Erro ao criar bot: ${error.message}`,
        });
      }
    },
    defaultTradingHours() {
      
      let defaultHours = this.$store.state.bot.defaultTradingHours;
      if(defaultHours) return defaultHours
      
      let days = ['monday','tuesday','wednesday','thursday','friday','saturday','sunday'];
      defaultHours = {};
      for(let day of days){
        defaultHours[day] = {
          opens: false,
          opensAt: null,
          closesAt: null,
        }
      }
      return defaultHours
    },
  },
  computed: {
    show: {
      get(): boolean {
        return this.showDialog;
      },
      set(showDialog: boolean) {
        if (!showDialog) {
          this.$emit("close");
        }
      },
    },
  },
  watch: {
    "$store.state.team.teams"(val) {
      this.teams = val;
    },
    bot(val) {
      this.newBot = (this as any).initializeBot(val);
    },
  },
});
